import styled from 'styled-components'
import { cores } from '../../styles'

import { TextSm } from '../../styles/text'

export const Container = styled.div`
  background-color: ${cores.corPrincipal};
  padding: 24px;
  color: #fff;
  text-align: center;

  h2 {
    margin-top: 20px;
  }
`

export const ListContainer = styled.ul`
  padding-left: 0;
  display: flex;
`

export const ListIconBlock = styled.div`
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  color: ${cores.corSecundaria};
`

export const ListItemBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  text-decoration: underline 1px;
`

export const ListItemFlex = styled.div`
  /* display: flex;
  justify-content: center; */
`

export const ListSocialIcon = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  p {
    margin-left: 16px;
  }
`

export const ListGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 80px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;

    li {
      width: 100%;
      display: flex;
      margin: 0 auto;
    }
  }
`

export const IconPlaceholder = styled.div`
  height: 40px;
  width: 40px;

  span {
    height: 100%;
    width: 100%;
  }
`

export const ContatoText = styled(TextSm)`
  margin: 0;
  text-align: left;
`
